// extracted by mini-css-extract-plugin
export default {"content":"OtcAssetsPage_content__xRFOX","loader":"OtcAssetsPage_loader__cTij5","stripes-animation-background-keyframes":"OtcAssetsPage_stripes-animation-background-keyframes__TcOhn"};